import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { isAuthenticated } from '@f/services/authentication/authentication.selectors';

import NavAuthenticated from './NavAuthenticated';
import NavNotAuthenticated from './NavNotAuthenticated';
import cls from './Header.module.css';

export default function () {
  const isUserAuthenticated = useSelector(state => isAuthenticated(state));

  return (
    <header className={cls.header}>
      {isUserAuthenticated && (
        <div className={cls.brandContainer}>
          <Link to="/dashboard" style={{ display: 'block' }}>
            <img src="/retroscore-logo-520.png" alt="M1 RetroScore powered by CAS" width="260" />
          </Link>
        </div>
      )}

      {isUserAuthenticated && <NavAuthenticated />}

      {!isUserAuthenticated && <NavNotAuthenticated />}
    </header>
  );
}
